import { DateTimeWithPrecision } from "@/Common/Models/DateTimeWithPrecision";
import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { CareElementFrequencyType } from "../CareElementFrequencyType";
import { BaseCareElement } from "./BaseCareElement";
import { CareElementType } from "./CareElementType";

export class FirstLineReviewedCareElement extends BaseCareElement {
    public CareElementType: CareElementType.FirstLineReviewed;
    public SubSectionName: string;
    public Frequency?: CareElementFrequencyType | null;

    public IsIntolerant?: boolean | null;
    public IsContraindicated?: boolean | null;
    public IsTargetReached?: boolean | null;
    public Agent?: string | null;
    public Dose?: string | null;

    public DateReviewed?: Date | null;
    public LastReviewedDate?: Date | null;
    public DateReviewedWithPrecision?: DateTimeWithPrecision | null;

    public constructor(init?: NonFunctionProperties<FirstLineReviewedCareElement>) {
        super();
        this.CareElementType = CareElementType.FirstLineReviewed;
        this.Name = init?.Name ?? "";
        this.SubSectionName = init?.SubSectionName ?? "";
        this.IsIntolerant = init?.IsIntolerant ?? null;
        this.IsContraindicated = init?.IsContraindicated ?? null;
        this.IsTargetReached = init?.IsTargetReached ?? null;
        this.Agent = init?.Agent ?? null;
        this.Dose = init?.Dose ?? null;
        this.DateReviewed = init?.DateReviewed ?? null;
        this.LastReviewedDate = init?.LastReviewedDate ?? null;
        this.DateReviewedWithPrecision = init?.DateReviewedWithPrecision ?? DateTimeWithPrecision.getDate(init?.DateReviewed);
        this.Frequency = init?.Frequency ?? null;
    }
}
